import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles, Breadcrumbs, Typography } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import ViewWeekIcon from '@material-ui/icons/ViewWeek';
import theme from '../../config/themaConfig';

const useStyles = makeStyles((theme) => ({
    link: {
        display: 'flex',
        color: '#0088FE',
        width: '10%',
        whiteSpace: 'nowrap',
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
        marginTop: '16%',
    },
    depositContext: {
        flex: 1,
    },
    page2Link: {
        color: '#48457c',
    },
    page3Link: {
        color: '#48457c',
    },
}));

export default function MigaPan({
    namePage,
    to,
    children,
    namePage2,
    to2,
    namePage3,
    to3,
}) {
    const classes = useStyles();
    const primaryColor = theme.palette.primary.main;

    return (
        <Breadcrumbs aria-label="breadcrumb" color="inherit">
            <Link
                color="inherit"
                to={to}
                className={`${classes.link} ${classes.page3Link}`}
            >
                <HomeIcon className={`${classes.icon} ${classes.page3Link}`} />
                {children}
            </Link>

            {namePage2 && to2 && (
                <Link
                    color="inherit"
                    to={to2}
                    className={`${classes.link} ${classes.page2Link}`}
                >
                    {namePage2}
                </Link>
            )}

            {namePage3 && to3 && (
                <Link style={{color:primaryColor}}to={to3} className={classes.link}>
                    {namePage3}
                </Link>
            )}

            <Typography style={{color:primaryColor}} className={`${classes.link} `} >
                <ViewWeekIcon color='primary' className={classes.icon}  />
                {namePage}
            </Typography>
        </Breadcrumbs>
    );
}
